import { render, staticRenderFns } from "./ConsulationTemp.vue?vue&type=template&id=25cc874b"
import script from "./ConsulationTemp.vue?vue&type=script&lang=js"
export * from "./ConsulationTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports